/** @format */

import React, { Component } from "react";
import { Badge } from "reactstrap";
import Icon from "./Icon";
import ModalQuickView from "./ModalQuickView";
import {
  setCookie,
  getCookie,
  eraseCookie,
  setLocalStorage,
  getLocalStorage,
  getUrlParam,
  setCookieOneHr,
} from "../global/browserFunctions";

import { EqualHeight, EqualHeightElement, EqualHeightConsumer } from 'react-equal-height';


class CardProduct extends Component {
  constructor(props) {
    super(props);
    var basePriceLevel = "1";
    var price =
      (props.product &&
        props.product.price_levels &&
        props.product.price_levels[basePriceLevel] &&
        props.product.price_levels[basePriceLevel].item___pricing_unitprice
          .value) ||
      "";

    if (price == "") {
      var child = props.product && props.product.child_items;
      child = child[Object.keys(child)[0]];
      var baseprice = (props.product && props.product.item_baseprice && props.product.item_baseprice.value) || "";
      price = Object.keys(child).length > 0 ? (child.price_levels[basePriceLevel] && child.price_levels[basePriceLevel].item___pricing_unitprice.value) : baseprice;
    }

    this.state = {
      product: this.props.product,
      masonry: this.props.masonry,
      quickView: false, //Quickview popup is hidden by default
      url:
        (props.product &&
          props.product.item_detailspage_url &&
          props.product.item_detailspage_url.value) ||
        "", //Directly assigning prop values else ""
      img:
        (props.product &&
          props.product.item_image_thumbnail_url &&
          props.product.item_image_thumbnail_url.value) ||
        "",
      description:
        (props.product &&
          props.product.item_storedescription &&
          props.product.item_storedescription.value) ||
        "",
      name:
        (props.product &&
          props.product.item_itemid_text &&
          props.product.item_itemid_text.value) ||
        "",
      price: price || "",
    };
    this.toggleModal = this.toggleModal.bind(this); //Function to show/hide add to cart modal/quickview modal
  }

  shouldComponentUpdate(nextProps, nextState) {
    // the items are populated from PLP, dynamically changes hence called this function

    if (this.state.product != nextProps.product) {
      this.setState({ product: nextProps.product }, function () {
        if (this.state.product) {

          var basePriceLevel = "1";
          var price =
            (this.state.product &&
              this.state.product.price_levels &&
              this.state.product.price_levels[basePriceLevel] &&
              this.state.product.price_levels[basePriceLevel]
                .item___pricing_unitprice.value) ||
            "";
          if (price == "") {
            var child = this.state.product && this.state.product.child_items;
            child = child[Object.keys(child)[0]];
            var baseprice = (this.state.product && this.state.product.item_baseprice && this.state.product.item_baseprice.value) || "";
            price = Object.keys(child).length > 0 ? (child.price_levels[basePriceLevel] && child.price_levels[basePriceLevel].item___pricing_unitprice.value) : baseprice;
          }
          this.setState({ url: this.state.product.item_detailspage_url.value }); //Set item data when item changes
          this.setState({
            img: this.state.product.item_image_thumbnail_url.value,
          });
          this.setState({
            description: this.state.product.item_storedescription.value,
          });
          this.setState({ name: this.state.product.item_itemid_text.value });
          this.setState({ price: price });
          this.forceUpdate(); //Sometimes the change happened but will not render, to resolve the issue this method is called
        }
      });
      return true;
    }
    return false;
  }
  toggleModal() {
    this.setState({ quickView: !this.state.quickView });
    this.forceUpdate(); //Sometimes the change happened but will not render, to resolve the issue this method is called
  }

  render() {
    return (

      <div className="product" data-aos="zoom-in" data-aos-delay="0">
        <div className="product-image mb-md-3">
          <a href={this.state.url ? `${this.state.url}` : ""}>
            {/*                         
                            {this.state.product.item___parent_image_thumbnail_url ?
                                this.state.masonry ?
                                    <img className="img-fluid" src={this.state.product.img.masonry.img} alt={this.state.product.img.masonry.alt} />
                                    :
                                    <div className="product-swap-image">
                                        <img className="img-fluid product-swap-image-front" src={this.state.product.img} alt={this.state.product.img.alt} />
                                        <img className="img-fluid" src={this.state.product.item___parent_image_thumbnail_url.value} alt="item_img"/>
                                    </div>
                                :
                                <img className="img-fluid" src={this.state.product.img.img} alt="product" />
                            } */}
            <EqualHeightElement>
              <EqualHeightConsumer>
                {context => (
                  <img className="img-fluid" src={this.state.img} alt="item_img" onLoad={() => (context.setForceUpdate(value => !value))} />
                )}
              </EqualHeightConsumer>
            </EqualHeightElement>
          </a>
          <div className="product-hover-overlay">
            <a
              className="text-dark text-sm"
              href="#"
              onClick={this.toggleModal}
            >
              <Icon className="svg-icon-heavy" icon="retail-bag-1" />
              <span className="ml-3 d-sm-inline">Add to cart</span>
            </a>
          </div>
        </div>
        <div className="position-relative">
          <h3 className="text-base mb-1">
            <a
              className="text-dark"
              href={this.state.url ? `${this.state.url}` : ""}
            >
              {this.state.name}
            </a>
          </h3>
          {this.state.price ? (
            <span className="text-gray-500 text-sm">${this.state.price} </span>
          ) : (
            ""
          )}

          {/* <span className="product-stars text-xs" >{this.state.product.InternalID}</span> */}
        </div>
        <ModalQuickView
          isOpen={this.state.quickView}
          toggle={() => this.toggleModal()}
          product={this.state.product}
          updateCartCount={this.props.updateCartCount}
        />
      </div>

    );
  }
}

export default CardProduct;
